import { darkTheme, lightTheme } from "@theme/themes";

import { ThemeUIProvider, useThemeUI } from "@theme/components";

import type { StrapiTheme } from "@ms/gatsby-site/src/types/strapi";
import type { MsTheme } from "@theme/themes";
import type { FC, ReactNode } from "react";

interface ThemeWrapperProps {
  children: ReactNode;
  theme?: MsTheme | StrapiTheme["value"];
}

export const getDesiredTheme = (theme?: string) => {
  if (!theme) return lightTheme;

  return theme.toUpperCase() === "DARK" ? darkTheme : lightTheme;
};

/**
 * Theme Wrapper
 *
 * This component is used to wrap components that need to be themed.
 *
 * If the theme prop is provided, it will check if that theme is different from the current theme.
 * If it is different, it will wrap the children in a ThemeUIProvider with the desired theme.
 * If it is the same, it will return the children as is.
 *
 * @param param0
 * @returns
 */
export const ThemeWrapper: FC<ThemeWrapperProps> = ({ children, theme = "LIGHT" }) => {
  const { theme: currentTheme } = useThemeUI();
  const desiredTheme = getDesiredTheme(theme);

  if (desiredTheme.name !== currentTheme.name) {
    return <ThemeUIProvider theme={desiredTheme}>{children}</ThemeUIProvider>;
  }

  return <>{children}</>;
};
